"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.optionButton = exports.StyledLabel = exports.SelectWrapper = exports.OptionsWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const calculateIndent = indent => {
  const BASE = 8;
  const INDENT_PADDING_LI = indent === 1 ? BASE * 2 : (indent + 1) * BASE;
  return /*#__PURE__*/(0, _react.css)("padding-left:", INDENT_PADDING_LI, "px!important;" + (process.env.NODE_ENV === "production" ? "" : ";label:calculateIndent;"));
};
const optionButton = indent => /*#__PURE__*/(0, _react.css)("padding-left:8px;padding-right:8px;justify-content:flex-start;height:100%;width:100%;&:disabled{opacity:0.5;}", indent && calculateIndent(indent), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:optionButton;"));
exports.optionButton = optionButton;
const SelectWrapper = exports.SelectWrapper = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "e1w1uyes2"
} : {
  target: "e1w1uyes2",
  label: "SelectWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "fnf23l",
  styles: "position:relative;ul{border-top:none;}"
} : {
  name: "fnf23l",
  styles: "position:relative;ul{border-top:none;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const OptionsWrapper = exports.OptionsWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1w1uyes1"
} : {
  target: "e1w1uyes1",
  label: "OptionsWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "6mff9q",
  styles: "position:absolute;left:0;right:0;min-width:150px;box-shadow:0px 10px 15px 0px rgba(0, 0, 0, 0.1);z-index:1000;border-radius:10px;overflow:hidden"
} : {
  name: "6mff9q",
  styles: "position:absolute;left:0;right:0;min-width:150px;box-shadow:0px 10px 15px 0px rgba(0, 0, 0, 0.1);z-index:1000;border-radius:10px;overflow:hidden",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "1wv5t7o",
  styles: "padding-right:25px"
} : {
  name: "1780abt-StyledLabel",
  styles: "padding-right:25px;label:StyledLabel;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const StyledLabel = exports.StyledLabel = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "e1w1uyes0"
} : {
  target: "e1w1uyes0",
  label: "StyledLabel"
})(({
  withInfo
}) => /*#__PURE__*/(0, _react.css)("line-height:22px;font-size:1em;font-weight:600;margin-bottom:4px;", withInfo && _ref2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledLabel;")));
var _ref = process.env.NODE_ENV === "production" ? {
  name: "eoqxuw",
  styles: "display:flex;justify-content:space-between;align-items:center;padding:0 0.5em;height:39px;background-color:rgba(216, 216, 216, 0.08);border:1px solid rgba(255, 255, 255, 0.24);border-radius:5px;color:white;&>button>span{color:white;font-weight:400;}button svg polygon{fill:white;}button{width:100%;}button+div{top:40px;}"
} : {
  name: "6fnvbj-opacity08",
  styles: "display:flex;justify-content:space-between;align-items:center;padding:0 0.5em;height:39px;background-color:rgba(216, 216, 216, 0.08);border:1px solid rgba(255, 255, 255, 0.24);border-radius:5px;color:white;&>button>span{color:white;font-weight:400;}button svg polygon{fill:white;}button{width:100%;}button+div{top:40px;};label:opacity08;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const styles = exports.styles = {
  default: process.env.NODE_ENV === "production" ? {
    name: "1iva4el",
    styles: "button{height:36px;padding-left:8px;padding-right:8px;svg{margin-left:8px;}}"
  } : {
    name: "12sjtjy-default",
    styles: "button{height:36px;padding-left:8px;padding-right:8px;svg{margin-left:8px;}};label:default;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  optionsWidth: width => /*#__PURE__*/(0, _react.css)("width:", width ? width : 'auto', ";" + (process.env.NODE_ENV === "production" ? "" : ";label:optionsWidth;")),
  width: width => /*#__PURE__*/(0, _react.css)("&>button{width:", width ? width : 'auto', ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:width;")),
  input: theme => /*#__PURE__*/(0, _react.css)("display:flex;flex-direction:column;width:100%;position:unset;border-color:", theme.border, ";position:relative;&:focus-within>span:first-of-type{color:", theme.primary, ";}&>button{display:flex;border:1px solid;padding:0 10px 0 10px;border-radius:5px;height:38px;border-color:inherit;&:hover,&:focus,&:active{border:1px solid ", theme.primary, ";text-decoration:none;}}" + (process.env.NODE_ENV === "production" ? "" : ";label:input;")),
  open: theme => /*#__PURE__*/(0, _react.css)("border-color:", theme.primary, ";color:", theme.primary, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:open;")),
  primary10: theme => /*#__PURE__*/(0, _react.css)("&>button,&>button:hover,&>button:focus{background-color:", theme.illustrationPrimary10, ";border-radius:9px;padding:0 0.7em;height:34px;}" + (process.env.NODE_ENV === "production" ? "" : ";label:primary10;")),
  inputstyle: hasLabel => /*#__PURE__*/(0, _react.css)("top:calc(", hasLabel ? '22px' : '0px', " + 38px + 5px);" + (process.env.NODE_ENV === "production" ? "" : ";label:inputstyle;")),
  withIcon: process.env.NODE_ENV === "production" ? {
    name: "ip9sq0",
    styles: "svg:first-of-type,polygon:first-of-type{margin-left:0;}"
  } : {
    name: "z72n3n-withIcon",
    styles: "svg:first-of-type,polygon:first-of-type{margin-left:0;};label:withIcon;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  opacity08: theme => _ref,
  maxHeight: maxHeight => /*#__PURE__*/(0, _react.css)("ul{overflow-y:scroll;max-height:", maxHeight, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:maxHeight;")),
  disabled: theme => /*#__PURE__*/(0, _react.css)("&>button,&>button:hover,&>button:focus{background-color:", theme.disabled, ";color:#999;border-color:", theme.border, ";cursor:not-allowed;text-decoration:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:disabled;")),
  infoButton: process.env.NODE_ENV === "production" ? {
    name: "1c9na83",
    styles: "position:absolute;right:0;top:0;button{display:block;height:24px!important;padding:0!important;}"
  } : {
    name: "1k55lp8-infoButton",
    styles: "position:absolute;right:0;top:0;button{display:block;height:24px!important;padding:0!important;};label:infoButton;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};